import React, { useContext, Fragment, useEffect, useRef, useState } from 'react';
import { STICKY_CART_OPTIONS } from 'lib/globals';
import { useMutation } from '@apollo/react-hooks';
import PageScrollContext from 'context/PageScrollContext';
import md5 from 'crypto-js/md5';
import {
    Page,
    Range,
    ColorPicker,
    FormGroup,
    Input,
    FormControl,
    Dropdown,
    Switch,
    CustomText,
    Icon,
    Button,
    Alert,
    VideoModal,
    RichEditor,
    ButtonSelect,
    MultiCurrencyModeAlerts
} from 'components';
import PreviewContext from 'context/PreviewContext';
import ShopContext from 'context/ShopContext';
import UserContext from 'context/UserContext';
import { GOOGLE_FONTS, CAMPAIGN_TYPES, SHOP_DEFAULT_SETTINGS, BREAK_POINTS } from 'lib/globals';
import { SAVE_SHOP_SETTINGS, UPDATE_SHOP_PROP } from 'lib/mutations';
import ExtraModules from 'screens/campaigns/settings/ExtraModules/index';
import CheckoutButton from 'screens/campaigns/settings/ExtraModules/CheckoutButton';
import { Loading, Toast, Modal } from '@shopify/app-bridge-react';
import { ShopConstraints } from 'Constraints';
import removeTypeName, { removeByType } from 'lib/removeTypeName';
import { Run } from 'lib/validate';
import { GET_SHOP_SETTINGS } from 'Queries';
import { PageHeader } from 'components/Page';
import { API, graphqlOperation } from 'aws-amplify';
import { APP_DEV } from 'aws-exports';
import Axios from 'axios';
import { Manager, Reference, Popper } from 'react-popper';
import Checkbox from 'react-simple-checkbox';
import styles from 'styles/cart_screen.module.scss';
import { useTransition } from 'react-spring';
import _ from 'lodash';
import classNames from 'lib/classNames';
import useReactRouter from 'use-react-router';
import { SET_ALL } from 'reducers/SetItemReducer';
import useRefState from 'hooks/useRefState';

const StickyCartSettings = (props) => {
    const { setIsStickyActVariantFocused } = useContext(PreviewContext);
    const stickyAlert = useRef(null);
    const { history, location } = useReactRouter();
    const [scrollTop, setScrollTop, scrollTopRef] = useRefState();
    const [cartActivateLoading, setCartActivateLoading] = useState(false);
    const [videoOne, setVideoOne] = useState(false);
    const [googleFonts, setGoogleFonts] = useState([]);
    const [hideTopBar, setHideTopBar] = useState(false);
    const [showConfirmActivate, setShowConfirmActivate] = useState(false);
    const [campaign_preview_visible, setCampaign_preview_visible] = useState(false);
    const campaign_preview_content_ref = useRef(null);
    const shopContext = useContext(ShopContext);
    const user = useContext(UserContext);
    const { state, discard, validationErrors, setValidationErrors, dispatch, setItem } =
        shopContext;

    const { sticky_cart } = state;

    const filterSettings = (settings) => {
        return removeByType(
            removeTypeName(
                Object.fromEntries(
                    Object.entries(settings).filter(([key]) => !['settingsSaved'].includes(key))
                )
            ),
            (v) => v !== '' && v !== null
        );
    };

    let [saveShopSettings, { data, error, loading }] = useMutation(SAVE_SHOP_SETTINGS, {
        refetchQueries: [
            {
                query: GET_SHOP_SETTINGS,
                variables: {
                    userId: user.attributes.website
                }
            }
        ]
    });
    const transitions = useTransition(
        !_.isEqual(state.original_settings, state.settings) && !hideTopBar,
        null,
        {
            from: { position: 'absolute', opacity: 0 },
            enter: { opacity: 1 },
            leave: { opacity: 0 },
            config: {
                duration: 300
            }
        }
    );
    const validate = (state, specific = []) =>
        Run(state, specific, {
            errors: validationErrors,
            setErrors: setValidationErrors,
            constraints: ShopConstraints
        });
    const save = (assign = {}, checkRTL = true) => {
        // console.log("state")
        // console.log(state.settings)
        // return
        if (validate(state)) return;
        if (
            checkRTL &&
            Object.keys(state.original_settings || {}).length &&
            state.settings.rtl !== state.original_settings.rtl
        ) {
            console.log(
                'updating theme',
                state.settings.rtl,
                state.original_settings.rtl,
                state.settings.active
            );
            return activateCart(state.settings.active, true, state.settings.rtl);
        }
        saveShopSettings({
            variables: {
                id: user.attributes.website,
                input: filterSettings(Object.assign(state.settings, assign))
            }
        });
    };

    const activateCart = async (active, confirmed = false, rtl = null) => {
        if (
            active &&
            !confirmed &&
            !state.settingsSaved &&
            _.isEqual(SHOP_DEFAULT_SETTINGS, state.settings)
        ) {
            return setShowConfirmActivate(true);
        }
        // setCartActivateLoading(true);
        // const { success } = await API.post("API_GATEWAY_NEW", "/cart/activate", {
        //   body: { active, rtl: rtl === null ? state.settings.rtl : rtl }
        // });
        // setCartActivateLoading(false);
        return save({ active }, false);
    };

    const handleOutSideClick = (event) => {
        if (!campaign_preview_content_ref.current) return;
        else if (campaign_preview_content_ref.current.contains(event.target)) return;
        setCampaign_preview_visible(false);
    };

    useEffect(() => {
        if (campaign_preview_visible)
            document.addEventListener('mousedown', handleOutSideClick, false);
        else document.removeEventListener('mousedown', handleOutSideClick, false);
        return () => {
            document.removeEventListener('mousedown', handleOutSideClick, false);
        };
    }, [campaign_preview_visible]);

    useEffect(() => {
        async function getGoogleFonts() {
            const { data } = await Axios.get(
                `https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key=AIzaSyCYLq50twmAe1_7jITZuehrERZWOjNqBCY`
            );
            setGoogleFonts(
                data.items.map(({ family, variants }) => ({
                    label: family,
                    value: `${family}:${variants.join()}`
                }))
            );
        }
        getGoogleFonts();
    }, []);

    useEffect(() => {
        setHideTopBar(!!data);
        if (APP_DEV) setTimeout(() => setHideTopBar(false), 1500);
    }, [data]);

    return (
        <Page
            background="none"
            getScrollTop={({ scrollTop }) => {
                setScrollTop(scrollTop);
            }}
            padding={0}
            header={{
                title: 'Settings',
                actions: []
            }}
            TopContent={{
                transitions,
                render: () => (
                    <Alert
                        type="save_settings"
                        title="unsaved changes"
                        borderPosition="none"
                        paddingX="px-6"
                        actions={[
                            {
                                text: 'Discard',
                                type: 'secondary',
                                loading: false,
                                onClick: () => discard()
                            },
                            {
                                text: 'Save',
                                type: 'primary',
                                loading: loading || cartActivateLoading,
                                onClick: () => save()
                            }
                        ]}
                    />
                )
            }}
        >
            <Fragment>
                {data && (
                    <Toast
                        content="Cart settings has been saved"
                        duration={3000}
                        onDismiss={() => {
                            setHideTopBar(false);
                        }}
                    />
                )}
                {(loading || cartActivateLoading) && <Loading />}
                <Alert
                    type={state.settings.sticky_cart.isActive ? 'success' : 'warning'}
                    icon={
                        state.settings.sticky_cart.isActive ? 'check-circle' : 'exclamation-circle'
                    }
                    title="Sticky Add To Cart"
                    withSwitch={{
                        context: [shopContext, 'settings.sticky_cart.isActive']
                    }}
                    className="z-5"
                >
                    <p>
                        {' '}
                        Keep Your Add To Cart Button Always Visible To Increase The Chances Of It
                        Being Pressed.
                    </p>
                </Alert>

                <Modal
                    title="Activating custom cart"
                    message="You're about to activate the cart with the default settings"
                    open={!!showConfirmActivate}
                    primaryAction={{
                        content: 'Activate',
                        destructive: true,
                        onAction: () => {
                            setShowConfirmActivate(false);
                            activateCart(true, true);
                        }
                    }}
                    secondaryActions={[
                        {
                            content: 'Cancel',
                            onAction: () => {
                                setShowConfirmActivate(false);
                                discard();
                            }
                        }
                    ]}
                />
                <FormGroup
                    label="Button Settings"
                    className="settings-row"
                    info="Setup the color and look of your sticky cart button"
                >
                    <FormControl label="Button Style">
                        <Dropdown
                            options={STICKY_CART_OPTIONS.btnStyles}
                            first
                            BindToContext={[shopContext, 'settings.sticky_cart.btn_style']}
                        />
                    </FormControl>
                    <FormControl label="Button Text">
                        <Input BindToContext={[shopContext, 'settings.sticky_cart.btn_text']} />
                    </FormControl>
                    <FormControl label="Unavailable Text">
                        <Input
                            // onFocus={() => setIsUnavailableFocused(true)}
                            // onBlur={() => setIsUnavailableFocused(false)}
                            BindToContext={[
                                shopContext,
                                'settings.sticky_cart.btn_text_unavailable'
                            ]}
                        />
                    </FormControl>
                    <FormControl label="Button Colors">
                        <div className="row three-columns">
                            <ColorPicker
                                text="Button Color"
                                colorType="hex"
                                BindToContext={[shopContext, 'settings.sticky_cart.btn_color']}
                            />
                            <ColorPicker
                                text="text Color"
                                colorType="hex"
                                BindToContext={[shopContext, 'settings.sticky_cart.txt_color']}
                            />
                            <ColorPicker
                                text="background Color"
                                colorType="hex"
                                BindToContext={[
                                    shopContext,
                                    'settings.sticky_cart.background_color'
                                ]}
                            />
                        </div>
                    </FormControl>
                </FormGroup>
                {/* //----------------------------------- */}

                <FormGroup label="Desktop Settings" info="Set settings for desktop sticky cart">
                    <FormControl
                        label="Activate Sticky Cart"
                        withSwitch={[shopContext, 'settings.sticky_cart.desktop_active']}
                    >
                        {' '}
                        <span></span>
                    </FormControl>
                    <FormControl
                        label="Show Variants Selector"
                        info="When turned off variants are selected from product"
                        withSwitch={[shopContext, 'settings.sticky_cart.desktop_show_variants']}
                    >
                        {' '}
                        <span></span>
                    </FormControl>
                    <FormControl
                        label="Show Quantity Selector"
                        withSwitch={[shopContext, 'settings.sticky_cart.desktop_show_quantity']}
                    >
                        {' '}
                        <span></span>
                    </FormControl>
                    <CustomText
                        context={shopContext}
                        label="Quantity text"
                        path="settings.sticky_cart.desktop_quantity"
                        hasNumber={false}
                        // hasWeight="700"
                    />
                    <FormControl
                        label="Show Product name"
                        withSwitch={[shopContext, 'settings.sticky_cart.desktop_show_product_name']}
                    >
                        {' '}
                        <span></span>
                    </FormControl>
                    <FormControl
                        label="Product Image Preview"
                        withSwitch={[shopContext, 'settings.sticky_cart.desktop_product_preview']}
                    >
                        {' '}
                        <span></span>
                    </FormControl>
                    <FormControl
                        label="Show compared price"
                        withSwitch={[
                            shopContext,
                            'settings.sticky_cart.desktop_show_compared_price'
                        ]}
                    >
                        {' '}
                        <span></span>
                    </FormControl>
                    <FormControl label="Desktop Visibilty">
                        <Dropdown
                            options={STICKY_CART_OPTIONS.visibilityOptions}
                            first
                            BindToContext={[shopContext, 'settings.sticky_cart.desktop_visibility']}
                        />
                    </FormControl>
                    <FormControl label="Desktop Location">
                        <Dropdown
                            options={STICKY_CART_OPTIONS.btnPosition}
                            first
                            BindToContext={[shopContext, 'settings.sticky_cart.desktop_location']}
                        />
                    </FormControl>
                </FormGroup>

                {/* //----------------------------------- */}
                <FormGroup label="Mobile Settings" info="Set settings for mobile sticky cart">
                    <FormControl
                        label="Activate Sticky Cart"
                        withSwitch={[shopContext, 'settings.sticky_cart.mobile_active']}
                    >
                        {' '}
                        <span></span>
                    </FormControl>
                    <FormControl
                        label="Show Variants Selector"
                        info="When turned off variants are selected from product"
                        withSwitch={[shopContext, 'settings.sticky_cart.mobile_show_variants']}
                    >
                        {' '}
                        <span></span>
                    </FormControl>
                    <FormControl
                        label="Show Quantity Selector"
                        withSwitch={[shopContext, 'settings.sticky_cart.mobile_show_quantity']}
                    >
                        {' '}
                        <span></span>
                    </FormControl>
                    <CustomText
                        context={shopContext}
                        label="Quantity text"
                        path="settings.sticky_cart.mobile_quantity"
                        hasNumber={false}
                        // hasWeight="700"
                    />
                    <FormControl
                        label="Show compared price"
                        withSwitch={[
                            shopContext,
                            'settings.sticky_cart.mobile_show_compared_price'
                        ]}
                    >
                        {' '}
                        <span></span>
                    </FormControl>

                    {/*New feature added*/}
                    <FormControl
                        label="Show product title"
                        withSwitch={[shopContext, 'settings.sticky_cart.mobile_show_title']}
                    >
                        {' '}
                        <span></span>
                    </FormControl>
                    <FormControl
                        label="Show product price"
                        withSwitch={[shopContext, 'settings.sticky_cart.mobile_show_price']}
                    >
                        {' '}
                        <span></span>
                    </FormControl>
                    {/*---------*/}
                    <FormControl label="Mobile Visibilty">
                        <Dropdown
                            options={STICKY_CART_OPTIONS.visibilityOptions}
                            first
                            BindToContext={[shopContext, 'settings.sticky_cart.mobile_visibility']}
                        />
                    </FormControl>
                    {state.settings.sticky_cart.mobile_show_variants && (
                        <>
                            <FormControl
                                label="Customize Button text when variant available"
                                withSwitch={[
                                    shopContext,
                                    'settings.sticky_cart.show_btn_atc_txt_variant_active'
                                ]}
                            >
                                <Input
                                    disabled={
                                        !state.settings.sticky_cart.show_btn_atc_txt_variant_active
                                    }
                                    onFocus={() => setIsStickyActVariantFocused(true)}
                                    onBlur={() => setIsStickyActVariantFocused(false)}
                                    BindToContext={[
                                        shopContext,
                                        'settings.sticky_cart.btn_atc_txt_variant_active'
                                    ]}
                                />
                            </FormControl>
                            <CustomText
                                context={shopContext}
                                label="Cart Name"
                                path="settings.sticky_cart.cart_name"
                                hasNumber={false}
                                // hasWeight="700"
                            />
                            <FormControl label="Button Text on variant picker active">
                                <Input
                                    BindToContext={[
                                        shopContext,
                                        'settings.sticky_cart.btn_text_variant_active'
                                    ]}
                                />
                            </FormControl>
                        </>
                    )}

                    <FormControl label="Mobile Location">
                        <Dropdown
                            options={STICKY_CART_OPTIONS.btnPosition}
                            first
                            BindToContext={[shopContext, 'settings.sticky_cart.mobile_location']}
                        />
                    </FormControl>
                    <FormControl>
                        <CustomText
                            context={shopContext}
                            label="ATC height"
                            path={`settings.sticky_cart.mobile_atc_height`}
                            hasColor={false}
                            hasNumber={false}
                            hasBU={false}
                            type="number"
                            icon={{ char: 'PX' }}
                            // colorType="hex"
                            step="1"
                        />
                    </FormControl>
                </FormGroup>
                <br />
                <br />
                <br />
                <br />
                <br />
            </Fragment>
        </Page>
    );
};

export default StickyCartSettings;
